module.exports = __webpack_public_path__ + "static/media/Savvy-Happy-Blink.b5b19772.png";